import { fetchCurrentUser, login, logout as logoutRequest } from '@/api/auth'
import { getToken, setToken, removeToken, getUser, setUser, removeUser } from '@/utils/auth'

const state = {
  token: getToken(),
  userInfo: getUser()
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
  }
}

const actions = {
  async login({ commit }, form) {
    const data = await login(form)
    const userInfo = normalizeUser(data)
    setToken(data.accessToken)
    setUser(userInfo)
    commit('SET_TOKEN', data.accessToken)
    commit('SET_USER_INFO', userInfo)
    return data
  },
  async loadCurrentUser({ commit, state }) {
    if (!state.token) {
      return null
    }
    const data = await fetchCurrentUser()
    const userInfo = normalizeUser(data)
    setUser(userInfo)
    commit('SET_USER_INFO', userInfo)
    return userInfo
  },
  clearSession({ commit, dispatch }) {
    removeToken()
    removeUser()
    commit('SET_TOKEN', '')
    commit('SET_USER_INFO', null)
    dispatch('permission/clear', null, { root: true })
  },
  async logout({ dispatch, state }) {
    if (state.token) {
      try {
        await logoutRequest()
      } catch (e) {
        // Local cleanup must still run when the token has already expired.
      }
    }
    dispatch('clearSession')
  }
}

function normalizeUser(data) {
  return {
    userId: data.userId,
    userName: data.userName,
    realName: data.realName,
    role: data.role || data.userRole,
    userRole: data.userRole || data.role,
    roleName: data.roleName,
    companyId: data.companyId,
    departmentId: data.departmentId,
    departmentName: data.departmentName,
    gender: data.gender,
    birthdayYear: data.birthdayYear,
    nation: data.nation,
    mobile: data.mobile,
    email: data.email,
    workLevel: data.workLevel,
    job: data.job,
    education: data.education,
    marriage: data.marriage,
    workYear: data.workYear,
    province: data.province,
    city: data.city,
    county: data.county,
    address: data.address,
    politics: data.politics,
    otherPolitics: data.otherPolitics,
    isReligion: data.isReligion,
    religion: data.religion,
    signature: data.signature,
    todoCount: data.todoCount || 0
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
